import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition } from '@/models/configuratorx/configuratorSchema';
import GordionRoom from '@/components/rooms/GordionRoom';


@Component({
  components: {
    GordionRoom,

  },
})
export default class Room extends Vue {
  private _configuratorService: ConfiguratorService = undefined;

  public get seletedProduct() {
    return Store.roomState.room;
  }



  @Inject()
  private _container: ComponentContainer;



  created() {



  }


  mounted() {

  }
}



// WEBPACK FOOTER //
// ./src/components/room/Room.ts